module.exports = __webpack_public_path__ + "static/media/annotation.37313db3.svg";